import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import _extends from "@babel/runtime/helpers/extends";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
export default function flattenStyle(style) {
  var flatStyle = _extends({}, StyleSheet.flatten(style));

  if (flatStyle.transform) {
    flatStyle.transform.forEach(function (transform) {
      var key = Object.keys(transform)[0];
      flatStyle[key] = transform[key];
    });
    delete flatStyle.transform;
  }

  return flatStyle;
}

if (typeof flattenStyle !== 'undefined' && flattenStyle && flattenStyle === Object(flattenStyle) && Object.isExtensible(flattenStyle) && !flattenStyle.hasOwnProperty('__filemeta')) {
  Object.defineProperty(flattenStyle, '__filemeta', {
    configurable: true,
    value: {
      name: "flattenStyle",
      filename: "node_modules/react-native-animatable/flattenStyle.js"
    }
  });
}